'use strict';

const BaseScene = require('./base-scene');
const { COLORS, GAME_WIDTH } = require('../config/constants');
const { drawGlowText, drawText, drawPlane } = require('../ui/draw');

class LoadingScene extends BaseScene {
  enter() {
    this.status = '正在同步飞行档案…';
    this.angle = 0;
    const startedAt = Date.now();
    this.app.bootstrap().then((online) => {
      this.status = online ? '档案同步成功' : '网络不稳定 · 使用本机缓存';
      const delay = Math.max(0, 650 - (Date.now() - startedAt));
      setTimeout(() => this.app.switchScene('home'), delay);
    });
  }

  update(dt) {
    this.angle += dt * 1.7;
  }

  render(ctx) {
    drawGlowText(ctx, '星际闪避', GAME_WIDTH / 2, 360, 76, COLORS.cyan);
    drawPlane(ctx, GAME_WIDTH / 2, 580 + Math.sin(this.angle * 2) * 12, 1.3, COLORS.cyan);
    ctx.save();
    ctx.strokeStyle = COLORS.purple;
    ctx.lineWidth = 8;
    ctx.lineCap = 'round';
    ctx.beginPath();
    ctx.arc(GAME_WIDTH / 2, 790, 34, this.angle, this.angle + Math.PI * 1.35);
    ctx.stroke();
    ctx.restore();
    drawText(ctx, this.status, GAME_WIDTH / 2, 865, 28, COLORS.muted);
  }
}

module.exports = LoadingScene;
